import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { Container } from '@fiverr-private/layout_components';
import Badge from '@fiverr-private/badges/dist/esm/src/components/Badge';
import { SellerLevelBadgeProps } from '../../../types';
import { SellerLevelDiamondIcon } from '../SellerLevelDiamondIcon';
import { appTranslate } from '../../../i18n/i18n';

export const SellerLevelTwoBadge = ({
    showTooltip = true,
    tooltipPosition = 'top',
    appendTooltipToBody,
    disableTooltipFlip,
}: SellerLevelBadgeProps) => (
    <Badge
        showTooltip={showTooltip}
        color="grey_100"
        backgroundColor="transparent"
        tooltipContent={appTranslate('badges.seller_level_two_badge.tooltip')}
        tooltipPosition={tooltipPosition}
        appendTooltipToBody={appendTooltipToBody}
        disableTooltipFlip={disableTooltipFlip}
        disablePadding={true}
    >
        <Container display="inlineFlex" gap="1" alignItems="center" justifyContent="center">
            <Typography size="b_xs" lineHeight="b_xxs" whiteSpace="nowrap">
                Level 2
            </Typography>
            <Container display="inlineFlex" gap="0.5">
                <SellerLevelDiamondIcon />
                <SellerLevelDiamondIcon />
                <SellerLevelDiamondIcon color="empty" />
            </Container>
        </Container>
    </Badge>
);

SellerLevelTwoBadge.displayName = 'SellerLevelTwoBadge';
